<div class="flex justify-between bg-grey-veryLight mb-3 p-2">
	<app-button [icon]="ICON.BACK" size="small" (click)="beforeClose()"
		>Back to file</app-button
	>
	<div class="flex items-center">
		<atomic-matter-type-icon [fileType]="fileType"></atomic-matter-type-icon>
		<span class="mx-3">{{ matterNumber }}</span>
		<span>{{ matterName }}</span>
	</div>
</div>

<div
	*ngIf="
		state === states.SENDING_DATA ||
		state === states.UPDATE_FILE ||
		state === states.LOADING_PORTAL
	"
	class="flex flex-1 flex-col justify-center items-center"
>
	<div class="w-64">
		<img
			src="/assets/images/integrations/stewart-title-logo.svg"
			alt="Stewart Title Logo"
		/>
	</div>
	<div class="mt-10 flex items-center">
		<app-icon
			[icon]="ICON.LOADING"
			class="text-4xl mr-3 text-grey"
			[spin]="true"
		></app-icon>
		<h4 class="text-grey">
			<span *ngIf="state === states.SENDING_DATA">Sending Data to Stewart</span>
			<span *ngIf="state === states.UPDATE_FILE">Updating order status</span>
			<span *ngIf="state === states.LOADING_PORTAL">Loading Portal</span>
		</h4>
	</div>
</div>

<div
	*ngIf="
		state === states.ERROR ||
		state === states.SET_PROFILE_ID_ERROR ||
		state === states.SET_PROFILE_ID
	"
	class="flex flex-col justify-center items-center"
>
	<div
		*ngIf="state === states.ERROR || state === states.SET_PROFILE_ID_ERROR"
		class="flex flex-col justify-center items-center border border-grey-light bg-grey-lightest p-5"
	>
		<div class="flex flex-col" *ngFor="let errorMessage of errorMessages">
			<p class="mb-4 text-center">
				<app-icon [icon]="ICON.WARNING" class="mr-4 text-orange"></app-icon
				>{{ errorMessage.Message }}
			</p>
			<div *ngFor="let fieldState of errorMessage.FieldStates">
				<p class="text-center">{{ fieldState.Message }}</p>
			</div>
		</div>
	</div>

	<div
		*ngIf="
			state === states.SET_PROFILE_ID || state === states.SET_PROFILE_ID_ERROR
		"
		class="flex justify-center items-center mt-10"
	>
		<form
			#myForm="ngForm"
			(ngSubmit)="saveProfileId(myForm.form)"
			class="flex-col gap-4 max-w-500"
		>
			<div class="flex gap-4 items-end">
				<app-input
					[(ngModel)]="profileId"
					[required]="true"
					[label]="'Stewart Title Profile Id for ' + assignedLawyer.name"
					name="profileId"
				></app-input>
				<app-button type="submit" [loading]="savingProfileId">Save</app-button>
			</div>
			<app-profile-id-message></app-profile-id-message>
			<div *ngIf="profileIdSaveError" class="mt-5" [@openClose]>
				<atomic-message-bar type="error">
					There was an error attempting to save your profile Id. Please try
					again.
				</atomic-message-bar>
			</div>
		</form>
	</div>
</div>

<div
	class="flex flex-1"
	*ngIf="state === states.SHOW_PORTAL || state === states.UPDATE_FILE"
	[style.visibility]="state === states.UPDATE_FILE ? 'hidden' : 'visible'"
>
	<div class="flex flex-col flex-1 w-full" *ngIf="iframeUrl">
		<iframe
			id="stewart-iframe"
			[src]="iframeUrl"
			width="100%"
			height="100%"
			class="flex flex-1"
		></iframe>
	</div>
</div>
